import React, { useEffect, Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

// Components
import Loading from "./components/Loading/Loading";
import SidebarSignature from "./components/SidebarSignature/SidebarSignature";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";

// Auth
import AuthLayout from "./auth/AuthLayout";
import Login from "./auth/Login";
import Register from "./auth/Register";

// Admin Layout (si tenés uno, sino lo comentamos)
import AdminLayout from "./admin/layout/AdminLayout";
import ProjectForm from "./admin/projects/ProjectsForm.jsx";
import BlogForm from "./admin/blog/BlogForm.jsx";

// Pages públicas
const Home = lazy(() => import("./pages/Home/Home"));
const About = lazy(() => import("./pages/About/About"));
const Projects = lazy(() => import("./pages/Projects/Projects"));
const ProjectDetail = lazy(() => import("./components/ProjectDetail/ProjectDetail"));
const Services = lazy(() => import("./pages/Services/Services"));
const Blog = lazy(() => import("./pages/Blog/Blog"));
const BlogDetail = lazy(() => import("./components/BlogDetail/BlogDetail"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound"));

// Admin pages
const Dashboard = lazy(() => import("./admin/Dashboard"));
const AdminProjects = lazy(() => import("./admin/projects/ProjectsAdmin"));
const AdminBlog = lazy(() => import("./admin/blog/BlogAdmin"));
const AdminServices = lazy(() => import("./admin/services/ServicesAdmin"));

// GA4
const TRACKING_ID = "G-K4PTNFWE94";
ReactGA.initialize(TRACKING_ID);

// Tracker de pageviews
const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <SidebarSignature />

      <Suspense fallback={<Loading />}>
        <Routes>
          {/* RUTAS PÚBLICAS */}
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetail />} />

          {/* AUTH – con layout bonito */}
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Route>

          {/* ADMIN – PROTEGIDAS */}
          <Route
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/admin" element={<Dashboard />} />
            <Route path="/admin/projects" element={<AdminProjects />} />
            <Route path="/admin/projects/new" element={<ProjectForm mode="new" />} />
            <Route path="/admin/projects/edit/:id" element={<ProjectForm mode="edit" />} />
            <Route path="/admin/blog" element={<AdminBlog />} />
            <Route path="/admin/blog/new" element={<BlogForm mode="new" />} />
            <Route path="/admin/blog/edit/:id" element={<BlogForm mode="edit" />} />
            <Route path="/admin/services" element={<AdminServices />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;